export default {
  components: {},
  data() {
    return {
      loading: false,
      isPopstate: false,
      transitionName: 'fade'
    };
  },
  computed: {
    fullPath() {
      return this.$route.fullPath;
    },
    path() {
      return this.$route.path;
    },
    keepAlive() {
      return (this.$route.meta || {}).keepAlive;
    },
    stateAudio() {
      const {
        audio
      } = this.$store.state;
      return audio;
    },
    visibleAudio() {
      const {
        visibleAudio
      } = this.$route.meta;
      return visibleAudio;
    }
  },
  methods: {
    handlePlay() {
      if (this.$audio.paused) {
        this.$audio.play();
      } else {
        this.$audio.pause();
      }
    }
  },
  mounted() {
    // 解决ios不支持按钮:active伪类的方法
    document.body.addEventListener('touchstart', () => {});
    // 解决ios输入表单被键盘顶上后无法恢复的问题
    let oldScrollTop = 0;
    document.addEventListener('focus', () => {
      oldScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    }, true);
    document.addEventListener('blur', () => {
      if (window.scrollTo) {
        window.scrollTo(0, oldScrollTop);
      }
    }, true);
    // 地址栏回退(前进也执行，无法判断)
    window.addEventListener('popstate', () => {
      this.isPopstate = true;
    });
    // this.$nextTick(() => {
    //   if (window.scrollTo) {
    //     const scrollTop = document.documentElement.scrollTop + 5;
    //     window.scrollTo(0, document.documentElement.scrollHeight);
    //     window.scrollTo(0, scrollTop);
    //   }
    // });
  },
  watch: {
    $route: {
      deep: true,
      handler(newValue) {
        // 路由切换效果(刷新浏览器是不使用)
        if (this.loading) {
          this.transitionName = this.isPopstate ? 'slide-router-right' : 'slide-router-left';
        }
        this.loading = true;
        this.isPopstate = false;

        // 滚动条自动滚动5px，然后回位(避免ios回退偶现白屏)
        const meta = newValue.meta || {};
        this.$nextTick(() => {
          if (window.scrollTo) {
            const scrollTop = document.documentElement.scrollTop + 5;
            window.scrollTo(0, document.documentElement.scrollHeight);
            window.scrollTo(0, scrollTop);
          }
        });

        // 没有启用分享配置的页面使用默认分享配置
        // if (!meta.visibleShare) {
        //   this.$nextTick(() => {
        //     const { href } = window.location;
        //     homeJssdkSignApi({
        //       debug: this.$route.query.debug,
        //     }).then(() => {
        //       weixinShare({ link: `${href.split('#')[0]}` });
        //     });
        //   });
        // }
        if (!meta.visibleAudio) {
          this.$audio.pause();
        } else {
          this.$audio.src = this.stateAudio.src;
          this.$audio.loop = true;
          this.$audio.play();
        }
      }
    }
  }
};